module.exports = __webpack_public_path__ + "img/code_girl.b0c351b1.png";